import { AxiosResponse } from "axios";

export const EGP_STORE_DETAILS_ERROR_CODE = "EGPStoreBranchCodeOrAddressInvalid";

export function isStoreDetailsIssueError(
  response?: AxiosResponse,
): boolean {
  return response?.data?.code === EGP_STORE_DETAILS_ERROR_CODE;
}

export function handleStoreDetailsIssueError(
  response: AxiosResponse | undefined,
  showDialog: () => void,
): boolean {
  if (!isStoreDetailsIssueError(response)) return false;
  showDialog();
  return true;
}
